export default __webpack_public_path__ + "static/media/BrainBreak cards103.fabd1905.png";